import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { DOWNLOAD_QR_IMAGE } from "../enums/ApiPaths";
import { fetchQrCodeSvg } from "../enums/queryFunction/Fetch";
import { QR_CODE_IMAGE } from "../enums/QueryKeys";
import api from "../utils/api/authApi";
import logger from "../utils/logger";

export function useQrCodeSvg(clinicId) {
  return useQuery({
    queryKey: [QR_CODE_IMAGE, clinicId],
    queryFn: () => fetchQrCodeSvg(clinicId),
    enabled: !!clinicId,
    retry: false,
  });
}

export function useDownloadQrCode() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const downloadQrCode = async (clinicId) => {
    if (!clinicId) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await api.get(
        `${DOWNLOAD_QR_IMAGE}${clinicId}`,
        {
          responseType: "blob",
        },
      );

      if (response.status === 200) {
        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `qrCode.svg`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }

      return true;
    } catch (err) {
      logger.error("Failed to download QR Code:", err);
      setError(err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { downloadQrCode, isLoading, error };
}
